export function getContentByParagraphID(id, type, storylineData) {
  let item = null;

  for (let part of storylineData) {
    for (let chapter of part.chapters) {
      for (let paragraph of chapter.paragraphs) {
        if (paragraph.paragraph_id === id) {
          item = paragraph[type];
        }
      }
    }
  }

  return item;
}

export function getEvidenceByID(evidence, id) {
  return evidence.find((evidence) => evidence.id === id);
}

export function getEvidenceFromMarkers(markers, id) {
  for (let marker of markers) {
    if (marker.marker_data.id === id) {
      return marker.marker_data.related_evidence;
    }
  }
}

/*
  Flattened data for mobile

  available types are:
  - part
  - chapter
  - paragraph
  - summary

  every item has an id and a label field.
  (summary has the part id with a `summary_` prefix)
*/
export function datamodelForSlides(data) {
  let result = [];
  for (let i = 0; i < data.length; i++) {
    result.push({
      i: i,
      part_count: i + 1,
      type: "part",
      id: data[i].id,
      title: data[i].title,
      label: "part",
    });

    for (let j = 0; j < data[i].chapters.length; j++) {
      result.push({
        part_count: i + 1,
        part_title: data[i].title,
        chapter_count: j + 1,
        type: "chapter",
        id: data[i].chapters[j].id,
        title: data[i].chapters[j].title,
        label: "chapter",
      });

      for (let k = 0; k < data[i].chapters[j].paragraphs.length; k++) {
        result.push({
          part_count: i + 1,
          part_title: data[i].title,
          chapter_count: j + 1,
          paragraph_count: k + 1,
          type: "paragraph",
          id: data[i].chapters[j].paragraphs[k].id,
          title: data[i].chapters[j].paragraphs[k].title,
          content: data[i].chapters[j].paragraphs[k].content,
          label: "paragraph",
        });
      }
    }

    result.push({
      type: "summary",
      id: "summary_" + data[i].id,
      title: data[i].summary_title,
      content: data[i].summary_content,
      media: data[i].summary_media,
      label: "summary",
    });
  }
  return result;
}

export function getPartChapterParagraphBy(data) {
  let chapterId = "";
  if (!!data.chapters) {
    if (data.chapters.length > 0) {
      chapterId = data.chapters[0].chapter_id;
    }
  }

  let paragraphId = "";
  if (chapterId !== "") {
    if (!!data.chapters[0].paragraphs) {
      if (!!data.chapters[0].paragraphs.length > 0) {
        paragraphId = data.chapters[0].paragraphs[0].paragraph_id;
      }
    }
  }

  return {
    id: data.id,
    chapter_id: chapterId,
    paragraph_id: paragraphId,
  };
}

export function getSpecificStoryLineData(id, type, storylineData) {
  let item = null;
  for (let part of storylineData) {
    if (type === "part") {
      if (part.id === id) {
        item = part;
      }
    }

    for (let chapter of part.chapters) {
      if (type === "chapter") {
        if (chapter.id === id) {
          item = chapter;
        }
      }

      for (let paragraph of chapter.paragraphs) {
        if (type === "paragraph") {
          if (paragraph.id === id) {
            item = paragraph;
          }
        }
      }
    }
  }

  return item;
}

export const getGlossaryData = (data, id, type) => {
  let result = "";

  const currentGlos = data;
  const currentId = id;
  if (currentGlos !== null) {
    if (!!currentGlos[currentId]) {
      if (type === "title") {
        result = currentGlos[currentId].title;
      } else if (type === "content") {
        result = currentGlos[currentId].content;
      } else if (type === "image") {
        result = currentGlos[currentId].image;
      }
    }
  }
  return result;
};

export const getParagraphsForRoute = (partID, storylineData) => {
  const paragraphs = [];
  const partTwo = getSpecificStoryLineData("deel_2", "part", storylineData);
  const partThree = getSpecificStoryLineData("deel_3", "part", storylineData);

  if (partID !== "deel_1") {
    for (let chapter in partTwo.chapters) {
      const curChapter = partTwo.chapters[chapter];
      for (let paragraph in curChapter.paragraphs) {
        paragraphs.push(curChapter.paragraphs[paragraph]);
      }
    }
    for (let chapter in partThree.chapters) {
      const curChapter = partThree.chapters[chapter];
      for (let paragraph in curChapter.paragraphs) {
        paragraphs.push(curChapter.paragraphs[paragraph]);
      }
    }
  }

  return paragraphs;
};
